module.exports = __webpack_public_path__ + "img/disable-blue-ticks-in-gb-whatsapp.8ab229dc.webp";